<div class="steps-padding">
    <div class="avatar-ques row" *ngIf="activePreQuestion ==1 || activePreQuestion ==2">
        <div class="avatar-question loginArea col-sm-12" *ngIf="activePreQuestion ==1">
            <div class="heading-title text-center pb-4">
                <h1 class="mb-5">Introduce Yourself</h1>
            </div>
            <h3>I am</h3>
            <div class="avatar-answers d-flex flex-col flex-sm-row flex-wrap mt-4">
                <a [class.highlight]="userProfileIndex == j" *ngFor="let profile of profiles;let j=index;"
                    class="avatar-answer mr-3 border radius-25 rounded-sm px-5 py-2 d-flex flex-row align-items-center text-decoration-none"
                    role="button" (click)="setProfile(j)">
                    <p class="">{{profile}}</p>
                </a>
            </div>
            <div class="actions mt-4">
                <button [disabled]="true" mat-stroked-button class="custom-button mr-4 back-btn text-left"><span
                    class="material-icons mr-2">
                        keyboard_backspace
                    </span>Back</button>
            </div>
        </div>

        <div class="avatar-question loginArea goal-area col-sm-10" *ngIf="activePreQuestion ==2">
            <div class="heading-title text-center pb-4">
                <h1 class="mb-5">Goal</h1>
            </div>
            <h3>Tell us what are your goals in life</h3>
            <div class="avatar-answers d-flex flex-col flex-sm-row flex-wrap mt-4">
                <a [class.highlight]="goalAnswerIndex == i" *ngFor="let goalAnswer of goalAnswers;let i=index;"
                    class="avatar-answer mr-3 border radius-25 rounded-sm px-5 py-2 d-flex flex-col align-items-center text-decoration-none"
                    role="button" (click)="setGoalIndex(i)">
                    <p class="">{{goalAnswer}}</p>
                </a>
            </div>
            <div class="actions mt-4">
                <button (click)="onClickBack(1)" mat-stroked-button class="custom-button mr-4 back-btn text-left"><span
                    class="material-icons mr-2">
                        keyboard_backspace
                    </span>Back</button>
            </div>
        </div>

    </div>

    <div class="id-data clearfix formArea col-sm-12" *ngIf="activePreQuestion == 3">
        <div class="heading-title text-center pb-4">
            <h1 class="mb-5">Introduce Yourself</h1>
        </div>
        <h4 class="mb-4">Fill your detail here</h4>
        <form [formGroup]="userForm" class="form-submit row">
            <div class="col-sm-10">
                <div class="row">
                    <div class="form-group mb-4 col-sm-6">
                        <input type="email" formControlName="email" class="form-control py-2 mb-2" aria-describedby=""
                            placeholder="Enter your email">
                        <div *ngIf="f.email.invalid && f.email.touched" class="relative">
                            <p class="caption status-danger" *ngIf="f.email.errors?.required">
                                Email is required!
                            </p>
                            <p class="caption status-danger" *ngIf="f.email.errors?.email">
                                Value is Invalid!
                            </p>
                        </div>
                    </div>
                    <div class="form-group mb-4 col-sm-6">
                        <input type="text" formControlName="firstName" class="form-control py-2 mb-2"
                            aria-describedby="" placeholder="Enter your first name">
                        <div *ngIf="f.firstName.invalid && f.firstName.touched" class="relative">
                            <p class="caption status-danger" *ngIf="f.firstName.errors?.required">
                                First Name is required!
                            </p>
                            <p class="caption status-danger" *ngIf="f.firstName.errors?.minlength">
                                Value is Invalid!
                            </p>
                        </div>
                    </div>
                    <div class="form-group mb-4 col-sm-6">
                        <input type="text" formControlName="lastName" class="form-control py-2 mb-2" aria-describedby=""
                            placeholder="Enter your last name">
                    </div>
                    <div class="form-group mb-4 col-sm-6">
                        <input type="text" formControlName="phone" class="form-control py-2 mb-2" aria-describedby=""
                            placeholder="Enter your phone number">
                        <div *ngIf="f.phone.invalid && f.phone.touched" class="relative">
                            <p class="caption status-danger" *ngIf="f.phone.errors?.pattern">
                                Value is Invalid!
                            </p>
                        </div>
                    </div>
                </div>


            </div>

        </form>
        <div class="d-flex flex-row align-items-center">
            <mat-checkbox [(ngModel)]="checked" class="example-margin text-gray-900">By checking this box you
                confirm that
                you have read our </mat-checkbox>
                <a color="primary" class="text-primary mb-2 ml-1" 
                routerLink="/pages/privacy-policy" target="_blank">Privacy Policy</a>
        </div>
        
        <div class="actions mt-4">
            <button (click)="onClickBack(2)" mat-stroked-button class="custom-button mr-4 back-btn text-left"><span
                    class="material-icons mr-2">
                    keyboard_backspace
                </span>Back</button>
            <button [disabled]="!userForm.valid || !checked" mat-flat-button color="primary" class="custom-button"
                (click)="onSave()"><span class="material-icons mr-2">
                </span>Submit</button>
        </div>
    </div>
</div>